import { ReactNode } from 'react'

import './HeroBanner.css'

interface HeroBannerProps {
  nameId: string
  children?: ReactNode
}

export default function HeroBanner({ nameId, children }: HeroBannerProps) {
  return (
    <section
      id="hero-banner"
      style={{ backgroundImage: `url(/images/hero-banner/${nameId}.jpg)` }}
    >
      <div className="container">{children}</div>
    </section>
  )
}
